<app-page-header
  title="Feedback abgeben"
  subtitle="Teile uns deine Erfahrungen, Ideen oder Wünsche mit."
  icon="rate_review"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-feedback-wrapper apple-slide-up">
  <div class="apple-feedback-grid">
    <div class="apple-card apple-feedback-card">
      <form class="apple-feedback-form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="apple-feedback-field" floatLabel="always">
          <mat-label>Deine Nachricht</mat-label>
          <textarea
            matInput
            rows="5"
            placeholder="Teile deine Erfahrungen, Ideen oder Wünsche..."
            [(ngModel)]="feedbackText"
            name="feedbackText"
          ></textarea>
        </mat-form-field>

        <div class="apple-feedback-rating">
          <span class="apple-feedback-rating-label">Bewertung</span>
          <div class="apple-feedback-stars">
            <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
              <button
                type="button"
                class="apple-rating-star"
                [class.filled]="rating.value >= i + 1"
                (click)="setRating(i + 1)"
                [attr.aria-label]="'Bewertung ' + (i + 1)"
              >
                <mat-icon>{{ rating.value >= i + 1 ? 'star' : 'star_border' }}</mat-icon>
              </button>
            </ng-container>
            <button
              type="button"
              class="apple-rating-clear"
              (click)="setRating(0)"
              [disabled]="rating.value === 0"
              [attr.aria-label]="'Bewertung zurücksetzen'"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="apple-feedback-actions">
          <button
            mat-flat-button
            color="primary"
            class="apple-button apple-button-primary apple-button-large"
            type="submit"
            [disabled]="!feedbackText && rating.value === 0"
          >
            <mat-icon>send</mat-icon>
            Absenden
          </button>
        </div>
      </form>
    </div>

    <aside class="apple-feedback-aside apple-card">
      <div class="aside-icon">
        <mat-icon>emoji_objects</mat-icon>
      </div>
      <h2 class="apple-heading-3">Warum Feedback wichtig ist</h2>
      <p class="apple-body-secondary">
        Dein Feedback hilft uns, Funktionen zu priorisieren und die Plattform kontinuierlich zu
        verbessern. Jede Rückmeldung wird gelesen und fließt in unsere Roadmap ein.
      </p>
      <ul class="apple-feedback-hints">
        <li>Sei konkret: Was hat dir gefallen oder gefehlt?</li>
        <li>Welche Schritte waren besonders hilfreich oder kompliziert?</li>
        <li>Gibt es Funktionen, die du dir wünschst?</li>
      </ul>
      <p class="apple-caption">
        Wir antworten dir per E‑Mail, wenn wir Rückfragen haben oder etwas umgesetzt wurde.
      </p>
    </aside>
  </div>
</div>
